var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreensearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "#197A56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1905 23.9022C25.1446 24.617 23.8799 25.035 22.5175 25.035C18.918 25.035 16 22.117 16 18.5175C16 14.918 18.918 12 22.5175 12C26.117 12 29.035 14.918 29.035 18.5175C29.035 19.8799 28.617 21.1446 27.9022 22.1905L32 26.2883L30.2883 28L26.1905 23.9022ZM22.5175 23.0296C25.0095 23.0296 27.0296 21.0095 27.0296 18.5175C27.0296 16.0255 25.0095 14.0054 22.5175 14.0054C20.0255 14.0054 18.0054 16.0255 18.0054 18.5175C18.0054 21.0095 20.0255 23.0296 22.5175 23.0296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreensearchIcon);
export default __webpack_public_path__ + "static/media/greensearch_icon.0928b14b815a4657decc99b3912eb8fd.svg";
export { ForwardRef as ReactComponent };